import Image, { type ImageProps } from 'next/image';

type ImageSrc = ImageProps['src'];

interface PictureProps extends Omit<ImageProps, 'src'> {
  src: ImageSrc;
  /** 생략 시 source 없이 src 단일 이미지로 렌더 (단일/반응형 모두 picture로 통일) */
  mobileSrc?: ImageSrc;
  /** 모바일 진입 브레이크포인트 (기본값: 1024px) */
  breakpoint?: number;
  /** mobileSrc가 string인 경우의 너비 */
  mobileWidth?: number;
  /** mobileSrc가 string인 경우의 높이 */
  mobileHeight?: number;
}

function resolveStatic(src: ImageSrc) {
  if (typeof src === 'string') return null;
  return 'default' in src ? src.default : src;
}

export function Picture({
  src,
  mobileSrc,
  breakpoint = 1024,
  alt,
  className,
  width,
  height,
  mobileWidth,
  mobileHeight,
  ...rest
}: PictureProps) {
  const pcStatic = resolveStatic(src);
  const moStatic = mobileSrc ? resolveStatic(mobileSrc) : null;
  const useNativeImg = typeof src === 'string' && !pcStatic && width == null && height == null;

  return (
    <picture className={className}>
      {mobileSrc && (
        <source
          media={`(max-width: ${breakpoint}px)`}
          srcSet={moStatic?.src ?? (mobileSrc as string)}
          width={moStatic?.width ?? mobileWidth}
          height={moStatic?.height ?? mobileHeight}
        />
      )}
      {useNativeImg ? (
        <img src={src} alt={alt} />
      ) : (
      <Image
          src={src}
          alt={alt}
          width={pcStatic?.width ?? width}
          height={pcStatic?.height ?? height}
          {...rest}
        />
      )}
    </picture>
  );
}
